import RatesGroups from "./RatesGroups";
export default RatesGroups;
